import { render, staticRenderFns } from "./MarketTask.vue?vue&type=template&id=24ccd1b0&"
import script from "./MarketTask.vue?vue&type=script&lang=js&"
export * from "./MarketTask.vue?vue&type=script&lang=js&"
import style0 from "./MarketTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports